"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Link = _interopRequireDefault(require("../Link/Link"));

var _iconExternalLink = _interopRequireDefault(require("../../icons/icon-external-link.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LinkRenderer = function LinkRendererComponent(_ref) {
  var href = _ref.href,
      children = _ref.children;
  var cleanHref = href;
  var forceNewTab = RegExp('{openNewTab}').test(cleanHref);

  if (forceNewTab) {
    cleanHref = href.replace('{openNewTab}', '');
  }

  var hasNoBase = RegExp('^/').test(cleanHref);
  var isHostUrl = RegExp(window.location.host).test(cleanHref);
  var openNewTab = forceNewTab || !(hasNoBase || isHostUrl);
  return /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    className: "custom-react-markdown__external-link",
    href: cleanHref,
    external: openNewTab
  }, children, "\xA0", /*#__PURE__*/_react["default"].createElement(_iconExternalLink["default"], {
    className: "custom-react-markdown__external-link-icon"
  }));
};

LinkRenderer.propTypes = {
  href: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element, _propTypes["default"].arrayOf(_propTypes["default"].element)]).isRequired
};
var _default = LinkRenderer;
exports["default"] = _default;